import { memo } from "react";

import { tw, type TTailwindString } from "classnames";

const styles = {
  klarna: tw("mt-7", "flex", "flex-col", "gap-2"),
  klarnaPrimary: tw(
    "h-2",
    "w-full",
    "max-w-[260px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder",
    "md:max-w-[340px]" as TTailwindString
  ),
  klarnaSecondary: tw(
    "h-2",
    "w-full",
    "max-w-[80px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder",
    "md:hidden"
  ),
};

const KlarnaPlaceholderBase = () => {
  return (
    <div className={styles.klarna}>
      <div className={styles.klarnaPrimary}></div>
      <div className={styles.klarnaSecondary}></div>
    </div>
  );
};

export const KlarnaPlaceholder = memo(KlarnaPlaceholderBase);
